import React, { useState, Fragment } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import { Tooltip } from "components"
import OhEditAddressInput from "./OhEditAddressInput"
import OhAddressOnMap from "./OhAddressOnMap"
import OhLalamoveMap from "./OhLalamoveMap"
import classes from "./index.module.scss"

const OhAddress = props => {
  const { order } = props

  const [t] = useTranslation()

  const systemIsActivated =
    useSelector(state => state.systemSettings.systemIsActivated)

  const [showAddressOnMap, setShowAddressOnMap] = useState(false)
  const [openLalamove, setOpenLalamove] = useState(false)

  const showLalamoveIcon =
    order.deliveryService === "snapbox"

  const address =
    typeof order.address === "string"
      ? { address: order.address }
      : order.address || {}
  const state = String(address.state || "")
  const city = String(address.city || "")
  const addressText = String(address.address || "")
  const zipCode = String(address.zipCode || "")
  const areaName = String(order.areaName || address.areaName || "")
  const note = String(address.note || "")
  const coordinates =
    Array.isArray(address.location?.coordinates)
      ? address.location.coordinates
      : []
  const hasCoordinates = coordinates.length >= 2

  return (
    <Fragment>
      <div className={classes["delivery"]}>
        <div className={classes["delivery-to"]}>
          <span className={classes["delivery-to-label"]}>
            {t("تحویل_به")}
          </span>

          <div className={classes["note"]}>
            {t("استان")}: <b>{state || "-"}</b>
          </div>

          <div className={classes["note"]}>
            {t("شهر")}: <b>{systemIsActivated ? city || "-" : "************"}</b>
          </div>

          <OhEditAddressInput
            type="address"
            value={addressText}
            onMapMarkerIconClick={() => setShowAddressOnMap(prev => !prev)}
          />

          {
            !!zipCode.trim() &&
            <div className={classes["note"]}>
              {t("کدپستی")}: <b>{zipCode}</b>
            </div>
          }


          <div className={classes["note"]}>
            {t("روش_ارسال")}: <b>{areaName || "-"}</b>
          </div>

          {
            !!note &&
            <div className={classes["note"]}>
              {t("یادداشت")}: <b>{note}</b>
            </div>
          }
        </div>
        {
          showLalamoveIcon &&
          <Tooltip title={t("موقعیت_ارسال")}>
            <img
              onClick={() => setOpenLalamove(prev => !prev)}
              className={classes["lalamove"]}
              src="/assets/images/Tracker.png"
              alt=""
            />
          </Tooltip>
        }
      </div>
      {
        showAddressOnMap && hasCoordinates &&
        <OhAddressOnMap
          lat={coordinates[0]}
          lng={coordinates[1]}
        />
      }
      {
        openLalamove &&
        <OhLalamoveMap order={order} />
      }
    </Fragment>

  )
}

export default OhAddress
